import React, { useEffect } from 'react';
import { Container } from '@mui/material';
import { makeStyles } from '@mui/styles'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import Page from 'src/components/Page';
import Header from './Header';
import AttributeForm from '../AttributeCreate/AttributeForm';
// import ProjectCreateForm from './ProjectCreateForm';
import MperitoCard from 'src/components/MperitoCard';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingTop: theme.spacing(3),
        paddingBottom: 100
    }
}));

function AttributeEdit() {
    const classes = useStyles();
    const { state } = useLocation();

    const businessInfo = useSelector((state) => state?.app?.businessInfo);
    const customerId = businessInfo?.customerId;

    useEffect(() => {

    }, [businessInfo]);

    return (
        <Page
            className={classes.root}
            title="Attribute Create"
        >
            <Container maxWidth={false}>
                <Header />
                <MperitoCard title={`Edit Attribute ( ${businessInfo?.businessName} - ${businessInfo?.customerId} )`}>
                    <AttributeForm customerId={customerId} data={state} />
                </MperitoCard>
            </Container>
        </Page>
    );
}

export default AttributeEdit;